import { createFileRoute } from "@tanstack/react-router";
import { EditLayout, ConsentSolutionProvider } from "@/features/consent-solutions";

const Route = createFileRoute("/_authorized/consent-solutions/$csId")({
  component: () => (
    <ConsentSolutionProvider>
      <EditLayout />
    </ConsentSolutionProvider>
  ),
});

export { Route };
